<template lang="pug">
	.creative-create-from-cocos-creator(v-if="showed")
		.card
			.card-header
				span Upload "Cocos Creator" creative
			.card-body.collapse.show(v-if="state === 'upload-build-files'")
				span Please upload
				b &nbsp;super-html.zip&nbsp;
				span file taken from Cocos Creator build files using super-html plugin. This zip can also contain
				b &nbsp;Settings/&nbsp;
				span folder with
				b &nbsp;default.json&nbsp;
				span settings file according to MraidSDK Settings documentation.
				//- Код креатива редактировался ИИ агентом: обновление перезапишет папку креатива и все эти правки будут затёрты
				.ai-code-edit-warning(v-if="process === 'update' && isAICodeEdited()")
					i.fa.fa-exclamation-triangle
					span The code of this creative was edited by the AI agent. Uploading a new super-html.zip will overwrite the creative code and all changes made by the AI agent will be lost.
				.progress.add-progress(:style="{visibility: isUploading ? 'visible' : 'hidden'}")
					.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (uploadProgress * 100) + '%'}")
			.card-body.collapse.show(v-if="state === 'confirm-data'")
				.form-horizontal
					.form-group.separator
						span Great! Now confirm parsed data or change it.
				.form-horizontal
					.form-group.separator
						label.col-form-label Creative title:
						input.form-control.title(size="16" type="text" v-model="title" @keyup.enter="confirm()")
			.card-body.collapse.show(v-if="state === 'finish'")
				.form-horizontal
					.form-group.separator
						span(v-if="process === 'create'") Well done! Your cocos creator creative ready.
						span(v-if="process === 'update'") Well done! Your cocos creator creative updated.
			.card-body.collapse.show(v-if="state === 'loading'")
				.processing
					.icon.fa.fa-spinner.fa-spin
			.card-body.collapse.show(v-if="state === 'error'")
				.text.danger Error: {{errorMessage}}
			.card-body.collapse.show
				.form-horizontal
					.form-actions
						button.btn.btn-warning(type="button" v-on:click="upload()" v-if="state === 'upload-build-files'")
							i.fa.fa-upload
							span Upload super-html.zip file
						button.btn.btn-dark.skip(type="button" v-on:click="skipFirstUpload()" v-if="state === 'upload-build-files' && process === 'update'") Skip
						button.btn.btn-primary(type="button" v-on:click="request()" v-if="state === 'upload-build-files' && process === 'create'") Request playable development
						button.btn.btn-warning(type="button" v-on:click="confirm()" v-if="state === 'confirm-data'")
							i.fa.fa-check
							span Confirm
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'
	import { Auth } from "../../services/Auth";

	export default {
		name: "PlayableCreateFromCocosCreator",
		mixins: [Screen],
		screen: {
			events: {
				"Show PlayableCreateFromCocosCreator": function(creativeId = null) {

					this.showed = true;
					this.firstUploadSkipped = false;
					this.state = "upload-build-files";
					this.creativeId = creativeId;
					this.process = creativeId ? "update" : "create";

				},
				"Server Data:UploadCocosBuildResult": function(parsedData) {

					this.state = "confirm-data";
					this.title = parsedData.title;

				},
				"Server Data:CocosCreativeCreated": function() {

					this.close();

				},
				"Server Data:CocosCreativeUpdated": function() {

					this.close();

				},
				"Server Data:UploadCocosCreativeError": function(errorMessage) {

					this.state = "error";
					this.errorMessage = errorMessage;

				}
			}
		},
		data() {

			this.process = "create";
			this.creativeId = null;

			return {
				showed: false,
				state: "upload-build-files", // "upload-build-files" > "confirm-data" > "finish" || "loading" || "error"
				errorMessage: '',
				title: '',
				isUploading: false,
				uploadProgress: 0,
				firstUploadSkipped: false
			};

		},
		methods: {
			collectData() {

			},
			upload() {

				this.uploadProgress = 0;

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "application/zip";

				input.addEventListener('change', e => {

					this.uploadBuildFiles(e.target.files[0]);

					document.body.removeChild(input);

				});

				input.addEventListener('blur', e => {

					document.body.removeChild(input);

				});

				input.click();

			},
			uploadBuildFiles(file) {

				let formData = new FormData();

				formData.append("publisherId", Publisher.SelectedPublisher.id);
				if (this.creativeId) formData.append("creativeId", this.creativeId);
				formData.append("file", file);

				let url = `${location.protocol}//${SetupSettings["domain"]}/creative/upload/${'cocos'}`;

				let xhr = new XMLHttpRequest();


				xhr.open("POST", url);
				Auth.authorizeRequest(xhr);

				xhr.upload.onprogress = e => {

					if (e.lengthComputable) {

						this.uploadProgress = e.loaded / e.total;

					}

				};

				xhr.upload.onloadstart = e => {

					this.isUploading = true;

				};

				xhr.upload.onloadend = e => {

					this.isUploading = false;

				};

				xhr.send(formData);

			},
			// Код креатива хотя бы один раз изменялся ИИ агентом (флаг в options креатива ставит сервер)
			isAICodeEdited() {

				return Creative.getCreative(this.creativeId)?.options['aiCodeEdited'] === true;

			},
			skipFirstUpload() {

				this.firstUploadSkipped = true;
				this.state = "upload-build-single-file";

			},
			confirm() {

				this.state = "loading";

				Server.sendToServer({
					CreateCocosCreativeConfirm: {
						title: this.title
					}
				});

			},
			request() {

				Broadcast.call("Show PlayableCreateRequest");

			},
			back() {

				this.firstUploadSkipped = false;
				this.state = "upload-build-files";

			},
			close() {

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.creative-create-from-cocos-creator
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		display: flex
		justify-content: center
		align-items: center

		.card
			width: 600px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			label
				white-space: nowrap
				margin-right: 10px

			.form-group
				display: flex
				flex-direction: row
				flex-wrap: nowrap

			.separator
				padding-bottom: 20px
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)

			b
				color: #ffc107

			.ai-code-edit-warning
				display: flex
				flex-direction: row
				align-items: baseline
				gap: 8px
				margin-top: 15px
				padding: 8px 12px
				border: 1px solid var(--warning)
				border-radius: 0.25rem
				background-color: rgba(255, 193, 7, 0.15)
				font-size: 13px

				i.fa
					color: var(--warning)

			.progress.add-progress
				height: 5px
				margin-top: 10px
				margin-bottom: 10px

			.danger
				color: var(--danger)

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.btn-ghost-dark, .btn-dark.skip
				float: none
				color: #fff

			.btn-primary, .btn-warning
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

</style>

